<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Cari Hesap Mizanı</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>


            </v-toolbar>
          </v-flex>
          <v-container fluid>
            <v-layout row wrap>


              <v-flex xs12 sm6 md4 style="padding-right:2px;padding-bottom:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamCariBorc }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamCariAlacak }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Cari Borç/Alacak</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">layers</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamGenelBorc }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamGenelAlacak }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Genel Toplam </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">business_center</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ toplamBakiye | bakiyekontrol }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Genel Bakiye</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>






            </v-layout>
          </v-container>


          <v-container fluid>
            <v-card color="grey lighten-5" flat>
              <v-form ref="formtarih" v-model="valid" lazy-validation>

                <v-layout row wrap>
                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>

                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>
                  </v-flex>


                  <v-flex>
                    <v-layout>
                      <div v-if="load1">
                        <v-btn color="info" @click="getList()" fab small="" dark>
                          <v-icon>search</v-icon>
                        </v-btn>
                      </div>
                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                        color="info" fab dark>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Arama Filtresi Ekle</span>
                      </v-tooltip>
                    </v-layout>
                  </v-flex>










                  <v-dialog v-model="dialogfiltre" scrollable persistent="" max-width="500px">
                    <v-card color="grey lighten-5">

                      <v-card-title>Filtre Seçimi</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text style="height: 500px;">


                        <v-flex pa-1 xs12 sm12 md12>
                          <v-card class="white--text">
                            <v-card color="grey lighten-5" flat="">
                              <v-card-actions>

                                <v-layout justify-space-between column>
                                  <v-autocomplete label="Hesap Kodu " hide-details clearable :loading="loading" v-model="MizanCari.Cari.Kod"
                                    append-icon="search" :items="hesapkodu" item-text="text" cache-items="" item-value="id"
                                    :search-input.sync="search"></v-autocomplete>

                                  <v-autocomplete label="Ana Hesap " hide-details clearable :loading="loading1" v-model="MizanCari.AnaHesap"
                                    append-icon="search" :items="anahesap" item-text="text" cache-items="" item-value="id"
                                    :search-input.sync="search1"></v-autocomplete>

                                  <v-select :items="hesapgurubu" v-model="MizanCari.HesapGrubu" hide-details="" label="İstenilen Hesap Gurubu"
                                    multiple item-text="Adi" item-value="Kod" max-height="400"></v-select>

                                  <v-select :items="hesapgurubu" v-model="MizanCari.NoHesapGrubu" hide-details="" label="İstenmeyen Hesap Gurubu"
                                    multiple item-text="Adi" item-value="Kod" max-height="400" persistent-hint></v-select>
                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-card>
                          <v-layout justify-space-between column>
                            <br>
                            <v-card flat="" color="#9E9E9E">
                              <v-card-title>
                                <span class="subheading white--text font-weight-medium "> Seçenekler</span>
                              </v-card-title>
                            </v-card>
                            <v-checkbox label="Bakiyesi Sıfır Olanlar Çıkmasın" hide-details="" v-model="MizanCari.BakiyeSifir"></v-checkbox>
                            <v-checkbox hide-details="" label="Sadece Borç Bakiyeleri Ver" v-model="MizanCari.SadeceBorcBakiye"></v-checkbox>
                            <v-checkbox hide-details="" label="Sadece Alacak Bakiyeleri Ver" v-model="MizanCari.SadeceAlacakBakiye"></v-checkbox>
                            <v-checkbox hide-details="" label="Peşin Müşterileri Hesaplama" v-model="MizanCari.PesinMusteri"></v-checkbox>
                            <v-checkbox hide-details="" label="Cari Dönemde Hareketi Olmayanlar Çıkmasın" v-model="MizanCari.CariDonemBakiyeli"></v-checkbox>
                            <v-checkbox hide-details="" label="Cari Dönemi Basma" v-model="MizanCari.CariDonemBasma"></v-checkbox>
                            <v-checkbox hide-details="" label="Carinin Son İşlem Tarihini Göster" v-model="MizanCari.SonIslemTarih"></v-checkbox>
                            <v-checkbox hide-details="" label="Fatura Tarihine Göre Mizan Al" v-model="MizanCari.FaturaTarih"></v-checkbox>
                            <v-checkbox hide-details="" label="Coper Faturlanmamış Kayıtları Gösterme" v-model="MizanCari.CoperKayitGosterme"></v-checkbox>
                            <v-checkbox hide-details="" label="Tüm Şirketler" v-model="tumsirketler"></v-checkbox>
                          </v-layout>
                        </v-flex>

                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                        <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-flex xs12 sm12>
                    <v-card>
                      <v-card-title>
                        <v-spacer></v-spacer>

                      </v-card-title>
                      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                        :search="search3">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                        <template slot="items" slot-scope="props">
                          <td class="text-xs-left">{{ props.item.CariKod }}</td>
                          <td class="text-xs-left">{{ props.item.CariUnvan }}</td>
                          <td class="text-xs-right">{{ props.item.CariBorc | moneyformat}}</td>
                          <td class="text-xs-right">{{ props.item.CariAlacak | moneyformat}}</td>
                          <td class="text-xs-right">{{ props.item.GenelBorc | moneyformat}}</td>
                          <td class="text-xs-right">{{ props.item.GenelAlacak | moneyformat }}</td>
                          <td class="text-xs-right">{{ props.item.GenelBakiye | bakiyekontrol }}</td>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          {{ search3 }} ile başlayan kayıt bulunamadı.
                        </v-alert>
                      </v-data-table>
                    </v-card>



                    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                      :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                      {{ text1 }}
                      <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                    </v-snackbar>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>
          </v-container>

        </v-layout>
      </v-card>
    </v-app>

  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from '../customcomp/tarihim'

  export default {
    data() {
      return {
        headers: [{
            text: ' Hesap Kodu',
            value: 'CariKod'
          },
          {
            text: 'Hesap Adı',
            value: 'CariUnvan'
          },
          {
            text: 'Cari Borç',
            value: 'CariBorc',
            align: 'right'

          },
          {
            text: 'Cari Alacak',
            value: 'CariAlacak',
            align: 'right'

          },
          {
            text: 'Genel Borç',
            value: 'GenelBorc',
            align: 'right'

          },
          {
            text: 'Genel Alacak',
            value: 'GenelAlacak',
            align: 'right'

          },
          {
            text: 'Genel Bakiye',
            value: 'GenelBakiye',
            align: 'right'

          }
        ],
        valid: true,
        MizanCari: {
          CariAlacak: '',
          CariBorc: '',
          CariKod: '',
          CariUnvan: '',
          GenelAlacak: '',
          GenelBakiye: '',
          GenelBorc: '',
          Sirketkodu: '',
          BaslangicTarih: '',
          BitisTarih: '',
          Cari: {
            SirketKodu: '',
            Kod: ''
          },
          AnaHesap: '',
          HesapGrubu: [],
          NoHesapGrubu: [],
          BakiyeSifir: false,
          SadeceBorcBakiye: false,
          SadeceAlacakBakiye: false,
          PesinMusteri: false,
          CariDonemBakiyeli: false,
          CariDonemBasma: false,
          SonIslemTarih: false,
          FaturaTarih: false,
          CoperKayitGosterme: false,
        },
        toplamBakiye: 0,
        toplamCariAlacak: 0,
        toplamCariBorc: 0,
        toplamGenelAlacak: 0,
        toplamGenelBorc: 0,
        toplamRisk: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        date2yedek: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        loading1: false,
        search3: '',
        renk: 'white',
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        butondurum: true,
        hesapkodu: [],
        anahesap: [],
        hesapgurubu: [],
        e6: [],
        progress: false,
        tumsirketler: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        search: '',
        search1: '',
        cariKod: '',
        tooltip: false,
        el: null,

        dictionary: {
          custom: {

            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },

        filtre: {
          a: '',
          b: '',
          c: ''
        },
        dialogfiltre: false
      }
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
    },

    watch: {
      search(val) {
        val && this.carigetir(val)
      },
      search1(val) {
        val && this.carigetir2(val)
      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
    methods: {
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      carigetir: carigetir,
      carigetir2: carigetir2,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    },
  }



  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.hesapkodu = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function carigetir2(v) {
    if (v.length >= 0) {
      this.loading1 = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.anahesap = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading1 = false
      }, 500)
    }
  }


  function getList() {

    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {


        this.progress = true
        this.toplamBakiye = 0
        this.toplamCariAlacak = 0
        this.toplamCariBorc = 0
        this.toplamGenelAlacak = 0
        this.toplamGenelBorc = 0
        this.load = true
        this.load1 = false

        if (this.tumsirketler === true) {
          this.MizanCari.Sirketkodu = '0'
        } else {
          var credentials = JSON.parse(window.localStorage.getItem('credentials'));
          this.MizanCari.Sirketkodu = credentials.SirketKodu
        }

        this.MizanCari.BaslangicTarih = this.date
        this.MizanCari.BitisTarih = this.date2

        var params = this.MizanCari

        this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrent', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body.List
          this.toplamBakiye = response.body.ToplamBakiye
          this.toplamCariAlacak = response.body.ToplamCariAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
            '$1,')
          this.toplamCariBorc = response.body.ToplamCariBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.toplamGenelAlacak = response.body.ToplamGenelAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
            '$1,')
          this.toplamGenelBorc = response.body.ToplamGenelBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
            '$1,')

          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true

          }
        })

      } else {
        this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
        this.snackbar = true
      }
    }
  }

  function getListHtml() {

    this.load = true
    this.load1 = false
    if (this.tumsirketler === true) {
      this.MizanCari.Sirketkodu = '0'
    } else {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.MizanCari.Sirketkodu = credentials.SirketKodu
    }

    this.MizanCari.Cari.SirketKodu = this.MizanCari.Sirketkodu
    this.MizanCari.BaslangicTarih = this.date
    this.MizanCari.BitisTarih = this.date2
    var params = this.MizanCari
    this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrentHtmlReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.load = false
      this.load1 = true
      var blob = new Blob([response.data], {
        type: 'application/html'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "Mizan.html";
      link.click();
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true
      }
    })
  }


  function getListExcel() {

    this.load = true
    this.load1 = false

    if (this.tumsirketler === true) {
      this.MizanCari.Sirketkodu = '0'
    } else {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.MizanCari.Sirketkodu = credentials.SirketKodu
    }

    this.MizanCari.BaslangicTarih = this.date
    this.MizanCari.BitisTarih = this.date2

    var params = this.MizanCari
    this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrentExcelReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      },
      responseType: "arraybuffer"
    }).then((response) => {
      this.load = false
      this.load1 = true
      var blob = new Blob([response.data], {
        type: 'application/xlsx'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "Mizan.xlsx";
      link.click();

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true

      }
    })
  }



  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.toplamBakiye = 0
    this.toplamCariAlacak = 0
    this.toplamCariBorc = 0
    this.toplamGenelAlacak = 0
    this.toplamGenelBorc = 0
    this.toplamRisk = 0
    this.load = true
    this.load1 = false
    this.date = helpers.getDateNow()
    this.date2 = helpers.getDateNow()
    this.MizanCari.BaslangicTarih = this.date
    this.MizanCari.BitisTarih = this.date2
    this.MizanCari.Sirketkodu = credentials.Sirketkodu

    var params = this.MizanCari


    this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrent', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body.List
      this.toplamBakiye = response.body.ToplamBakiye
      this.toplamCariAlacak = response.body.ToplamCariAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.toplamCariBorc = response.body.ToplamCariBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.toplamGenelAlacak = response.body.ToplamGenelAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.toplamGenelBorc = response.body.ToplamGenelBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.toplamRisk = response.body.ToplamRisk.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.load = false
      this.load1 = true
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true
      }
    })

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

  }

  function filtrele() {
    this.dialogfiltre = true
  }

  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'

    this.dialogfiltre = false
    this.MizanCari.Cari.Kod = null,
      this.MizanCari.Cari.Sirketkodu = null,
      this.MizanCari.AnaHesap = '',
      this.MizanCari.HesapGrubu = [],
      this.MizanCari.NoHesapGrubu = [],
      this.MizanCari.BakiyeSifir = false,
      this.MizanCari.SadeceBorcBakiye = false,
      this.MizanCari.SadeceAlacakBakiye = false,
      this.MizanCari.PesinMusteri = false,
      this.MizanCari.CariDonemBakiyeli = false,
      this.MizanCari.CariDonemBasma = false,
      this.MizanCari.SonIslemTarih = false,
      this.MizanCari.FaturaTarih = false,
      this.MizanCari.CoperKayitGosterme = false
    this.tumsirketler = false
  }
</script>

<style>
</style>